import { render } from "./LeastPrivilege.vue?vue&type=template&id=5b801ba8&scoped=true"
import script from "./LeastPrivilege.vue?vue&type=script&lang=js"
export * from "./LeastPrivilege.vue?vue&type=script&lang=js"

import "./LeastPrivilege.vue?vue&type=style&index=0&id=5b801ba8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b801ba8"

export default script